export default {
  coffeeData: {
    windBreaker: "Windbrekerboom",
    horticultureInfo: "Boom in de tuinbouw",
    shadeTree: "Schaduwboom",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoorten",
    coffeeCherryQuality: "Kwaliteit van koffiekers",
    processingBatchQuality: "Kwaliteit van verwerkingsbatch",
    greenCoffeeQuality: "Kwaliteit van groene koffie",
    processType: "Proces Type",
    updateWindBreaker: "Windbrekerboomtype bijwerken",
    addWindBreaker: "Nieuw type windbrekerboom toevoegen",
    updateHorticultureInfo:
      "Informatie over het boomtype in de tuinbouw bijwerken",
    addHorticultureInfo:
      "Nieuwe informatie over boomtype in de tuinbouw toevoegen",
    updateShadeTree: "Schaduwboomtype bijwerken",
    addShadeTree: "Nieuw schaduwboomtype toevoegen",
    updateCoffeeVariety: "Koffievariëteit bijwerken",
    addCoffeeVariety: "Nieuw type boom van koffievariëteit toevoegen",
    deleteVarietyTitle: "Variëteit verwijderen",
    deleteVarietyMessage:
      "Weet je zeker dat je deze variëteit wilt verwijderen?",
    updateCoffeeSpecie: "Koffiesoort bijwerken",
    deleteSpecieTitle: "Soort verwijderen",
    deleteSpecieMessage: "Weet je zeker dat je deze soort wilt verwijderen?",
    addCoffeeSpecie: "Nieuwe koffiesoort toevoegen",
    variety: "Variëteit",
    selectVariety: "Variëteit selecteren",
    deleteCoffeeRecord: "Weet je zeker dat je het record wilt verwijderen?",
    deleteCoffeeData: "Koffiegegevens verwijderen",
    topicRequired: "Naam van het onderwerp is vereist",
    coffeeAddSuccess: "Koffiesoort succesvol toegevoegd.",
    treeTypeSuccess: "Boomtype succesvol toegevoegd.",
    treeTypeUpdateSuccess: "Boomtype succesvol bijgewerkt.",
    coffeeVarietySuccess: "Koffievariëteit succesvol toegevoegd.",
    coffeeSpecieSuccess: "Koffiesoort succesvol bijgewerkt.",
    nameRequired: "Naam is vereist",
    notFound: "Geen koffie-admin-gegevens gevonden",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoOverview: "Cacao Overzicht",
    cacaoVariety: "Cacao Variëteit",
    cacaoSpecies: "Cacao Soort",
    deleteCacaoData: "Cacaogegevens verwijderen",
  },
  memberDataSection: {
    import: "Importeren",
    buyingStation: "Aankoopstation",
    factory: "Fabriek",
    factories: "Fabrieken",
    factoriesName: "Fabrieksnaam",
    factoriesProdChart: "Fabrieken produktiegrafiek",
    factoryInfo: "Fabrieksinformatie",
    continue: "Doorgaan",
    farmerId: "Boerderij-ID",
    farmerName: "Naam van de boer",
    farmerAddress: "Adres van de boer",
    quality: "Kwaliteit",
    quantity: "Hoeveelheid",
    importAll: "Alles importeren",
    importSelected: "Geselecteerde importeren",
    fileLoaded: "Bestand succesvol geladen",
    incorrectHeaders: "Onjuiste koppen",
    processingBatch: "Batch verwerken",
    purchaseOrder: "Inkooporder",
    startDate: "Startdatum",
    endDate: "Einddatum",
    selectCrop: "Selecteer Gewas",
    purchasingOrder: "Inkooporder",
    totalCoffeeCherry: "Totaal koffiekers",
    airHumidity: "Luchtvochtigheid",
    density: "Dichtheid",
    temperature: "Temperatuur",
    beanMoistureContent: "Vochtgehalte van de boon",
    processType: "Procestype",
    batchRating: "Batchbeoordeling selecteren",
    purchaseDate: "Aankoopdatum",
    selectFarmer: "Boer selecteren",
    selectFarm: "Boerderij selecteren",
    selectPlantation: "Plantage selecteren",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoort",
    coffeeCherryQuantity: "Hoeveelheid koffiekers",
    coffeeCherryQuality: "Kwaliteit van koffiekers",
    coffeeType: "Koffietype",
    pricePerKg: "Prijs per kg",
    processingDone: "Verwerking voltooid",
    processedCoffeeOut: "Verwerkte koffie geleverd",
    farmer: "Boer",
    farm: "Boerderij",
    plantation: "Plantage",
    farmers: "Boeren",
    farmLimitUsed: "Limiet van boerderij gebruikt",
    phoneNumber: "Telefoonnummer",
    farmSize: "Grootte van de boerderij",
    farmLocation: "Boerderij/Locatie",
    date: "Datum",
    status: "Toestand",
    noFarmers: "Geen boeren gevonden",
    approveReject: "Goedkeuren/Afwijzen",
    farms: "Boerderijen",
    crops: "Gewassen",
    equipment: "Apparatuur",
    noFarms: "Geen boerderijen gevonden",
    views: "Weergaven",
    selectStatus: "Status selecteren",
    approved: "Goedgekeurd",
    rejected: "Afgewezen",
    reject: "Afwijzen",
    approve: "Goedkeuren",
    cancel: "Annuleren",
    add: "Toevoegen",
    describeYourReason: "Beschrijf hier uw reden",
    userInformation: "Gebruikersinformatie",
    userFarmRequest: "Boerderijaanvraag van gebruiker",
    userFarmInformation: "Boerderijinformatie van gebruiker",
    activity: "Activiteit",
    activityType: "Type activiteit",
    farmZone: "Boerderijzone",
    farmerView: "Boerenweergave",
    cropType: "Gewastype",
    cropVariety: "Variëteit van het gewas",
    area: "Gebied",
    cost: "Kosten",
    geofence: "Geofence",
    map_views: "Kaartweergaven",
    viewAllFarms: "Alle boerderijen bekijken",
    farmersDetails: "Details van de boer",
    download: "Downloaden",
    pOrder: {
      addNew: "Nieuwe toevoegen",
      viewAll: "Alles bekijken",
      selectDate: "Datum selecteren",
      makeSelection: "Maak een keuze",
      coffeeType: "Koffietype",
      enterPrice: "Prijs invoeren",
      reqPurchaseDate: "Aankoopdatum is verplicht",
      reqFarmer: "Boer is verplicht",
      reqCoffeeQnty: "Hoeveelheid koffiekers is verplicht",
      reqPrice: "Prijs per kg is verplicht",
      grandTotal: "TOTAAL",
      selectDateRange: "Selecteer datumbereik",
      import: "Importeren",
      purchaseId: "Inkoop-ID",
      purchaseDate: "Aankoopdatum",
      farmerName: "Naam van de boer",
      quality: "Kwaliteit",
      quantity: "Hoeveelheid",
      pricePerKg: "Prijs per kg",
      selectBuyingStation: "Aankoopstation selecteren",
      searchUser: "Gebruikers zoeken",
  },
  // Buying Station specific translations
    buyingStations: "Inkoopstations",
    registerBuyingStation: "Inkoopstation Registreren",
    registerFactory: "Fabriek Registreren",
    loadingFactory: "Fabriek wordt geladen...",
    loadingBuyingStation: "Inkoopstation wordt geladen...",
    searchBuyingStation: "Inkoopstation Zoeken",
    searchFactory: "Fabriek Zoeken",
    nameAndId: "Naam / ID",
    email: "E-mail",
    mobileNumber: "Mobiel nummer",
    role: "Rol",
    actions: "Acties",
    view: "Bekijken",
    edit: "Bewerken",
    activate: "Activeren",
    deactivate: "Deactiveren",
    operator: "Operator",
    supplier: "Leverancier",
    active: "Actief",
    deactivated: "Gedeactiveerd",
    activatedSuccessfully: "Inkoopstation succesvol geactiveerd",
    deactivatedSuccessfully: "Inkoopstation succesvol gedeactiveerd",
    deletedSuccessfully: "Aankoopstation succesvol verwijderd",
    duplicatedSuccessfully: "Aankoopstation succesvol gedupliceerd",
  
    factoryActivatedSuccessfully: "Fabriek succesvol geactiveerd",
    factoryDeactivatedSuccessfully: "Fabriek succesvol gedeactiveerd",
    factoryRegisteredSuccessfully: "Fabriek succesvol geregistreerd",
    
    // Buying Station Details specific translations
    userDetails: "Gebruikersdetails",
    name: "Naam",
    provinceState: "Provincie/Staat",
    villageCityTown: "Dorp/Stad/Plaats",
    country: "Land",
    associatedFarms: "Gekoppelde Boerderijen",
    back: "Terug",
    addPurchaseOrder: "Inkooporder Toevoegen",
    search: "Zoeken",
    orderId: "Order ID",
    farmFarmer: "Boerderij / Boer",
    coffeeSpeciesVariety: "Koffiesoort / Variëteit",
    quantityPrice: "Hoeveelheid / Prijs",
    delete: "Verwijderen",
    
    // Processing Batch specific translations
    addProcessingBatch: "Verwerkingsbatch Toevoegen",
    batchId: "Batch ID",
    lots: "Partijen",
    greenCoffeeOut: "Groene Koffie Uit",
    startEndDate: "Startdatum / Einddatum",
    
    // Associated Farms specific translations
    addFarm: "Boerderij Toevoegen",
    farmNameAndId: "Boerderijnaam & ID",
    addressOfProduction: "Productieadres",
    areaHa: "Oppervlakte (ha)",
    type: "Type",
    eudrDeforestationStatus: "EUDR Ontbossingsstatus",
    eudrDeforestationStatusTT: "EUDR Risicobeoordeling Ontbossing",
    zeroNegligibleProbability: "Zero/Verwaarloosbare Waarschijnlijkheid",
    assessments: "Beoordelingen",
    riskAssessment: "Risicobeoordeling",
    compliant: "Conform",
    nonCompliant: "Niet-conform",
    pending: "In behandeling",
    dateOfSubmission: "Datum van Indiening",
    dateOfExpiry: "Vervaldatum",
    
    greenCoffee: {
      processGreenCoffee: "Groene Koffie Verwerken",
      lotIdOutturnNo: "Lot-ID / Productienummer",
      startDate: "Startdatum",
      complete: "Voltooid",
      quantity: "Hoeveelheid",
      totalGreenBeansExceeded: "De totale beoordeelde hoeveelheid mag het totaal groene bonen niet overschrijden.",
      toAddRecord: "om een record toe te voegen.",
      registeredSuccess: "Groene koffie succesvol geregistreerd",
      exportNotImplemented: "Exporteren niet geïmplementeerd",
      processingBatchRequired: "Verwerkingsbatch is verplicht",
      outturnAvailable: "Productienummer is beschikbaar",
      outturnExists: "Dit productienummer bestaat al. Voer een uniek nummer in.",
      totalGreenBeansRequired: "Totaal groene bonen is verplicht",
      enterHere: "Voer hier in",
      viewTitle: "Kwaliteitsbeoordeling groene bonen",
      parchmentInformation: "Pergamininformatie",
      processInformation: "Procesinformatie",
      greenBeansInformation: "Informatie groene bonen",
      traceabilityLabel: "Traceerbaarheidslabel",
      waste: "Afval",
      downloadLabel: "Label downloaden",
      startCupping: "Start cupping",
      cuppingHistory: "Cuppinggeschiedenis",
      noDataFound: "Geen gegevens gevonden.",
      noParchmentBatches: "Geen pergaminobatches gekoppeld.",
      noQualityGrades: "Geen kwaliteitsbeoordelingen geregistreerd.",
      batchId: "Batch-ID",
      species: "Soort",
      variety: "Variëteit",
      process: "Proces",
      batchRating: "Batchbeoordeling",
      humidity: "Vochtigheid",
      totalCoffeeCherryQty: "Totaal koffiekershoeveelheid",
      weightBeforeProcessing: "Gewicht vóór verwerking",
      numberOfBags: "Aantal zakken",
      externalId: "Externe ID",
      qrCode: "QR-code",
      latestCuppingScore: "Laatste cuppingscore",
      totalWaste: "Totaal afval",
      close: "Sluiten",
      unitSizeKgBag: "Eenheidsgrootte (kg/zak)",
      grade: "Graad",
      selectGrade: "Selecteer graad",
      quantityRequired: "Hoeveelheid is verplicht",
      quantityMustBePositive: "Hoeveelheid moet groter zijn dan 0",
      unitSizeRequired: "Eenheidsgrootte is verplicht",
      unitSizeMustBePositive: "Eenheidsgrootte moet groter zijn dan 0",
      gradeRequired: "Graad is verplicht",
      labelRequired: "Label is verplicht",
      cupping: "Cupping",
      cuppingInformation: "Cuppinginformatie",
      cupperName: "Naam proever",
      cuppingDate: "Cuppingdatum",
      enterCupperName: "Voer naam proever in",
      attachFiles: "Bestand(en) bijvoegen",
      selectFilesToUpload: "Selecteer bestand(en) om gegevens te uploaden",
      orDragAndDrop: "of sleep en zet hier neer",
      sessionDetails: "Sessiedetails",
      noCuppingHistory: "Geen cuppinggeschiedenis voor deze groene koffie.",
      cuppingDataSaved: "Cuppinggegevens opgeslagen.",
      date: "Datum",
      roast: "Branding",
      score: "Score",
      outturnNumber: "Productienummer",
      totalQuantity: "Totale hoeveelheid",
      supplier: "Leverancier",
      density: "Dichtheid",
      airHumidity: "Luchtvochtigheid",
      batchProductionDensity: "Batchproductiedichtheid",
      qualityScore: "Kwaliteitsscore",
      percentagePrimaryDefect: "Percentage primair defect",
      percentageSecondaryDefect: "Percentage secundair defect",
      totalGreenBeans: "Totaal groene bonen (kg)",
      leftoverQuantity: "Resterende hoeveelheid",
      expiryDate: "Vervaldatum",
      label: "Label",
      qualityControl: "Kwaliteitscontrole",
      packing: "Verpakking",
      totalBags: "Totaal zakken",
      percentage: "Percentage",
    },
    confirmDialog: {
      delete: {
        title: "Inkoopstation Verwijderen",
        message: "Weet u zeker dat u dit inkoopstation wilt verwijderen?",
        confirmBtn: "Verwijderen",
      },
      activate: {
        title: "Activeren",
        message: "Weet u zeker dat u dit {entity} wilt activeren?",
        confirmBtn: "Activeren",
      },
      deactivate: {
        title: "Deactiveren",
        message: "Weet u zeker dat u dit {entity} wilt deactiveren?",
        confirmBtn: "Deactiveren",
      },
    },
    
    registerNewFactory: "Nieuwe Fabriek Registreren",
    selectHowYouWantToProceed: "Selecteer hoe u wilt doorgaan",
    single: "Enkelvoudig",
    multiple: "Meervoudig",
    user: "Gebruiker",
    createNewFactory: "Nieuwe Fabriek Aanmaken",
    factoryName: "Fabrieksnaam",
    factoryNumber: "Fabrieksnummer",
    firstName: "Voornaam",
    lastName: "Achternaam",
    primaryEmailAddress: "Primair E-mailadres",
    submit: "Verzenden",
    downloadTemplate: "Download Modell",
    templateInfo: "Download het modelbestand om het vereiste formaat te zien voor de massa-registratie.",
    templateFormat: "Voer het bestand in CSV-formaat in.",
    selectFileToUpload: "Selecteer het bestand om de gegevens te uploaden",
    uploadFileOrDragAndDrop: "of sleep en laad hierheen",
} 
};
